import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { State } from 'model/State';
import { selectAccountHistory } from 'modules/mac/duck/selectors';
import { atlassianCloudKeys } from 'util/mac/helpers';
import { Dimensions } from 'components/visuals';
import { StyledFlex, StyledTextLabel } from '../StyledComponents';
import { messages } from '../../../messages';
import { ATLASSIAN_ORGANISATION } from 'data/products/keys';
import AccountHistory from './licensesRowHistory';

const HistorySection = ({ accountDetails, productKey }) => {
  const { id } = accountDetails;

  const accountHistory: any = useSelector((state) => selectAccountHistory(state as State, id));

  const accountWithoutHistory = [...atlassianCloudKeys, ATLASSIAN_ORGANISATION];
  const showHistory =
    !accountWithoutHistory.includes(productKey) && accountHistory?.periods?.length > 1;

  return (
    showHistory && (
      <StyledFlex>
        <StyledTextLabel width={`${Dimensions.units(3.4)}%`}>
          <FormattedMessage {...messages.history} />
        </StyledTextLabel>
        <AccountHistory accountHistory={accountHistory} />
      </StyledFlex>
    )
  );
};

export default HistorySection;
